import registerExtension from './registerExtension';
import imageAlt from './imageAlt';
import countries from '../../site-render/src/intl/messages/countries';

export default {
  ...imageAlt,
  ...registerExtension,
  ...countries,
  required: {
    pt: 'obrigatório',
    en: 'required',
    es: 'obligatorio',
  },
  sending: {
    pt: 'Enviando',
    en: 'Sending',
    es: 'Enviando',
  },
  sent: {
    pt: 'Enviado',
    en: 'Sent',
    es: 'Enviado',
  },
  invalidPostalCode: {
    pt: 'CEP inválido',
    en: 'invalid postal code',
    es: 'código postal inválido',
  },
  invalidEmail: {
    pt: 'e-mail inválido',
    en: 'invalid email',
    es: 'email inválido',
  },
  invalidPhone: {
    pt: 'telefone inválido',
    en: 'invalid phone',
    es: 'teléfono inválido',
  },
  invalidDocument: {
    pt: 'cpf/cnpj inválido',
    en: 'invalid cpf/cnpj',
    es: 'cpf/cnpj inválido',
  },
  invalidDate: {
    pt: 'data inválida',
    en: 'invalid date',
    es: 'fecha inválida',
  },
  unavailableVideoTitle: {
    pt: 'Este vídeo não existe',
    en: "This video doesn't exist",
    es: 'Ese video no existe',
  },
  unavailableVideoDescription: {
    pt: 'Verifique se a URL está correta',
    en: 'Check if the URL is correct',
    es: 'Comprueba si la URL es correcta',
  },
  highlightedVideo: {
    pt: 'Vídeo em destaque',
    en: 'Highlighted video',
    es: 'Video destacado',
  },
  genericError: {
    pt: 'Ocorreu um erro inesperado, tente novamente',
    en: 'An unexpected error has occurred, try again',
    es: 'Ha ocurrido un error inesperado, inténtalo de nuevo',
  },
};



// WEBPACK FOOTER //
// ./src/intl/messages/index.js